export default {
  MESSAGE_EVENT_NAME: 'message',
  AUTHENTICATION_EVENT_NAME: 'authentication',
  JOIN_ROOM_EVENT_NAME: 'join-room',
  CONNECT_EVENT_NAME: 'connect',
  ROOM_NAME: 'controlroom',
  INCOMING_NOTIFICATION_EVENT_NAME: 'incoming-event',
  DISCONNECT_EVENT_NAME: 'disconnect',
  NOTIFICATION_SERVER_URL: `${process.env.REACT_APP_SOCKET_URL}`,
};
